export {
  default,
  ResultGlassProps,
  ResultType,
  SharingType,
} from "./ResultGlass";
